import { t } from 'i18next';
import moment from 'moment';
import { TrainingObjectiveItem } from 'src/app/pages/ObjectiveManagement/objectiveManagement.config';
import { flowOMMEnums } from 'src/enums/flow.enum';
import { StateResultType } from 'src/types/services/state-service.type';

export type OntologyTypeList = { abbreviation: string };

export interface Item {
  id: string;
  eventId: string; // Event
  trainingObjectiveNumber: string | undefined;
  trainingObjective: string | undefined;
  creationDate: Date | undefined;
  relatedAudienceEntities: OntologyTypeList[]; // Ontology
  relatedAudienceProcesses: OntologyTypeList[]; // Ontology
  observerTrainerConditions: string | undefined;
  observerTrainerConditionStatus: string | undefined;
  battleRhythmConditions: string | undefined;
  battleRhythmConditionStatus: string | undefined;
  scenarioConditions: string | undefined;
  milConditions: string | undefined;
  exerciseControlConditions: string | undefined;
  trainingAudienceConditions: string | undefined;
  cisConditions: string | undefined;
  simulationConditions: string | undefined;
  scenarioConditionStatus: string | undefined;
  milConditionStatus: string | undefined;
  exerciseControlConditionStatus: string | undefined;
  trainingAudienceConditionStatus: string | undefined;
  cisConditionStatus: string | undefined;
  simulationConditionStatus: string | undefined;
  trainingObjectiveStatus: string | undefined;
  rowColor: string | undefined;
  objectiveTypeId: string;
  deducedFromObjectiveId: string | undefined;
}

export const defaultTrainingObjectiveData = (stateNodeList: StateResultType[]) => {
  return {
    id: '',
    eventId: '',
    trainingObjectiveNumber: '',
    trainingObjective: '',
    creationDate: moment(new Date()),
    modificationDate: moment(new Date()),
    relatedStandards: 'AJP-3',
    relatedAudienceEntities: [],
    relatedAudienceProcesses: [],
    observerTrainerConditions: t('OMM.objective.toBeAnalyzed'),
    observerTrainerConditionStatus: stateNodeList.find(
      (e) => e.flowChartType === flowOMMEnums.OBSERVER_TRAINER_CONDITION && e.isDefault === true,
    )?.id,
    battleRhythmConditions: t('OMM.objective.toBeAnalyzed'),
    battleRhythmConditionStatus: stateNodeList.find(
      (e) => e.flowChartType === flowOMMEnums.BATTLE_RHYTHM_CONDITION && e.isDefault === true,
    )?.id,
    scenarioConditions: t('OMM.objective.toBeAnalyzed'),
    scenarioConditionStatus: stateNodeList.find(
      (e) => e.flowChartType === flowOMMEnums.SCENARIO_CONDITION && e.isDefault === true,
    )?.id,
    milConditions: t('OMM.objective.toBeAnalyzed'),
    milConditionStatus: stateNodeList.find(
      (e) => e.flowChartType === flowOMMEnums.MIL_CONDITION && e.isDefault === true,
    )?.id,
    exerciseControlConditions: t('OMM.objective.toBeAnalyzed'),
    exerciseControlConditionStatus: stateNodeList.find(
      (e) => e.flowChartType === flowOMMEnums.EXERCISE_CONTROL_CONDITION && e.isDefault === true,
    )?.id,
    trainingAudienceConditions: t('OMM.objective.toBeAnalyzed'),
    trainingAudienceConditionStatus: stateNodeList.find(
      (e) => e.flowChartType === flowOMMEnums.TRAINING_AUDIENCE_CONDITION && e.isDefault === true,
    )?.id,
    cisConditions: t('OMM.objective.toBeAnalyzed'),
    cisConditionStatus: stateNodeList.find(
      (e) => e.flowChartType === flowOMMEnums.CIS_CONDITION && e.isDefault === true,
    )?.id,
    simulationConditions: t('OMM.objective.toBeAnalyzed'),
    simulationConditionStatus: stateNodeList.find(
      (e) => e.flowChartType === flowOMMEnums.SIMULATION_CONDITION && e.isDefault === true,
    )?.id,
    description: '',
    subtasks: '',
    log: '',
    comment: '',
    trainingObjectiveStatusId: stateNodeList.find((status) => status.flowChartType === 1 && status.isDefault === true)
      ?.id,
    attachments: [],
    objectiveTypeId: '',
    objectiveOverwrittenValue: null,
    deducedFromObjectiveId: '',
  };
};

export interface TrainingObjectivePropsType {
  trainingObjectiveData: TrainingObjectiveItem[];
}

export const deleteConfirmTitles = () => ({
  title: t('general.deleteConfirmTitle'),
  okText: t('general.no'),
  cancelText: t('general.yes'),
});
